import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { BsModalRef, BsModalService } from "ngx-bootstrap";

// Import Model
import { SortCompanyModel } from "../../../../model/builk/company-manage/company-sort";
import { UserlistModel } from "../../../../model/builk/user-manager/get-users";
import { UserModel } from "../../../../model/builk/user-manager/user.model";
import { CompanyManagelistModel } from "../../../../model/builk/company-manage/company-list";
// Import Enum
import { SortType } from "../../../../enum/jubili/company-manage/sort-type";
// Service
import { UserManagerService } from "../../../../service/api/builk/user-manager.service";
import { ResetPasswordModel } from '../../../../model/builk/user-manager/reset-password.model';

@Component({
  selector: "bo-builk-user-detail",
  templateUrl: "./user-manager-detail.component.html",
  styleUrls: ["./user-manager-detail.component.scss"]
})
export class UserManagerDetailComponent implements OnInit {
  @ViewChild("template") template: TemplateRef<any>;
  haveActivateDate = false;
  constructor(
    private modalService: BsModalService,
    public router: Router,
    private userManagerService: UserManagerService
  ) { }

  // using for sort user
  userDetail: UserModel = new UserModel();
  modalRef: BsModalRef;
  userList: UserlistModel = new UserlistModel();
  resetPasswordModel: ResetPasswordModel = new ResetPasswordModel();
  resetSuccess = false;
  @Input() userCompanyList: Array<CompanyManagelistModel>;

  @Output() isSaved = new EventEmitter();

  ngOnInit(): void {
    this.haveActivateDate = this.userDetail.activateDate ? true : false;
  }

  openModal(userDetail): void {
    this.resetPasswordModel.password = "";
    this.resetSuccess = false;
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-lg"
    });
    this.userDetail = userDetail;
    this.haveActivateDate = this.userDetail.activateDate ? true : false;
  }

  updateStatusEmailActive(userEmail: string): void {
    this.userList.userEmail = userEmail;
    // this.userList.userEmail = "saharat+6@builk.com";
    const encodeEmail = encodeURIComponent(this.userList.userEmail);
    this.userManagerService.updateEmailActiveStatus(encodeEmail)
      .subscribe(
        Response => {
          this.haveActivateDate = Response;
        },
        err => {
          // unauthorized refresh token
          console.log("Can't updateStatusEmailActive");
        }
      );
  }

  updateStatusEmailLock(userEmail: string, lockoutEnabled: boolean): void {
    this.userList.userEmail = userEmail;
    // this.userList.userEmail = "saharat+6@builk.com";
    this.userList.lockoutEnabled = lockoutEnabled ? false : true;
    this.userManagerService.updateStatusEmailLock(this.userList)
      .subscribe(
        response => {
          // this.isSaved.emit(true);
          this.userDetail.statusEmail = response;
          this.userDetail.lockoutEnabled = this.userDetail.statusEmail === "enable" ? true : false;
        },
        err => {
          // unauthorized refresh token
          console.log("Can't updateStatusEmailLock");
        }
      );
  }
  resetNewPassword(userEmail: string): void {
    this.resetPasswordModel.email = userEmail;
    console.log(this.resetPasswordModel);
    this.userManagerService.resetPassword(this.resetPasswordModel)
      .subscribe(response => {
        if (response === true) {
          this.resetPasswordModel.password = "";
          this.resetSuccess = true;
        }
      });
  }
}
